import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { GenericHttpClientService } from '@shared/services';
import { HttpDprContext } from '@shared/enums';

@Injectable()
export class DprExportDataService {
  constructor(private genericHttpClientService: GenericHttpClientService) {}

  exportData(): Observable<HttpResponse<ArrayBuffer>> {
    return this.genericHttpClientService.get<HttpResponse<ArrayBuffer>>({
      context: HttpDprContext.ExportData,
      responseType: 'arraybuffer',
      observeResponse: true,
    });
  }
}
